import { connect } from 'react-redux';
import { Translate } from '../../../../shared/LanguageService';
import {
    Button,
    Radio,
    Col,
    ControlLabel,
    FormControl,
    FormGroup,
    HelpBlock,
    Panel,
    Row,
    Tooltip,
    Checkbox
} from 'react-bootstrap';
import { ICurrency } from '../../Entities';
import CheckboxInput from '../../../../components/common/CheckboxInput';
import * as React from 'react';

interface IScandphotosCreateOrderConfirmationPageProps {
    addressInfo: any;
    contactInfo: any;
    selectedProduct: any;
    additionalProducts: any;
    objectTypes: any[];
    nrOfPlans: number;
    currency: ICurrency;
}

class ScandphotosCreateOrderConfirmationPage extends React.Component<
    IScandphotosCreateOrderConfirmationPageProps,
    any
> {
    constructor(props: any, context: any) {
        super(props, context);
    }

    objectIsApartment(objectType: number) {
        try {
            return Number(objectType) === 1;
        } catch (ex) {
            return false;
        }
    }

    objectIsVilla(objectType: number) {
        try {
            return Number(objectType) === 2;
        } catch (ex) {
            return false;
        }
    }

    render() {
        let objectType = this.props.objectTypes.filter((x) => {
            return x.value === parseInt(this.props.addressInfo.objectType);
        })[0];
        return (
            <fieldset>
                <Col md={6}>
                    <FormGroup>
                        <ControlLabel>
                            {Translate(
                                'scandphotos/orders/create/subview/order-confirm/label/seller'
                            )}
                        </ControlLabel>
                        <p>
                            {this.props.contactInfo.ownerFirstName}{' '}
                            {this.props.contactInfo.ownerLastName}
                        </p>
                        <p>{this.props.contactInfo.ownerPrimaryPhoneNumber}</p>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <ControlLabel>
                            {Translate(
                                'scandphotos/orders/create/subview/order-confirm/label/package'
                            )}
                        </ControlLabel>
                        <p>{this.props.selectedProduct.name}</p>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <ControlLabel>
                            {Translate(
                                'scandphotos/orders/create/subview/order-confirm/label/object'
                            )}
                        </ControlLabel>
                        <p>{this.props.addressInfo.addressLine1}</p>
                        <p>
                            {this.props.addressInfo.addressPostalNumber}{' '}
                            {this.props.addressInfo.addressCity}
                        </p>
                        <p>{Translate(objectType.displayName)}</p>
                        {this.objectIsApartment(this.props.addressInfo.objectType) && (
                            <p>
                                {Translate(
                                    'scandphotos/orders/create/subview/order-confirm/label/number-of-rooms'
                                )}
                                : {this.props.addressInfo.objectNumberOfRooms}
                            </p>
                        )}
                        {this.objectIsApartment(this.props.addressInfo.objectType) && (
                            <p>
                                {Translate(
                                    'scandphotos/orders/create/subview/order-confirm/label/storey'
                                )}
                                : {this.props.addressInfo.apartmentFloor}
                            </p>
                        )}
                        {this.objectIsApartment(this.props.addressInfo.objectType) && (
                            <p>
                                {Translate(
                                    'scandphotos/orders/create/subview/order-confirm/label/balcony-existence'
                                )}
                                : {this.props.addressInfo.apartmentHasBalcony}
                            </p>
                        )}
                        {this.objectIsApartment(this.props.addressInfo.objectType) && (
                            <p>
                                {Translate(
                                    'scandphotos/orders/create/subview/order-confirm/label/entry-code'
                                )}
                                : {this.props.addressInfo.apartmentAccessCode}
                            </p>
                        )}
                        {this.objectIsVilla(this.props.addressInfo.objectType) && (
                            <p>
                                {Translate(
                                    'scandphotos/orders/create/subview/order-confirm/label/area'
                                )}
                                : {this.props.addressInfo.objectAreaSquareMeters}
                            </p>
                        )}
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <ControlLabel>
                            {Translate(
                                'scandphotos/orders/create/subview/order-confirm/label/additions'
                            )}
                        </ControlLabel>
                        {this.props.additionalProducts.map((product, index) => {
                            return <p key={`product-confirmation${index}`}>{product.name}</p>;
                        })}
                    </FormGroup>
                </Col>
            </fieldset>
        );
    }
}

export default ScandphotosCreateOrderConfirmationPage;
